import Api from '../../../helpers/Api';

export const SET_CLIENTS_DATA = 'SET_CLIENTS_DATA';
const setClientsData = (clientsData, allLocations) => ({
    type: SET_CLIENTS_DATA,
    clientsData,
    allLocations,
});

export const SET_CLIENTS_SINGLE_DATA = 'SET_CLIENTS_SINGLE_DATA';
const setClientsSingleData = (clientsSingleData) => ({
    type: SET_CLIENTS_SINGLE_DATA,
    clientsSingleData,
});

export const SET_IS_LOADING_CLIENTS_DATA = 'SET_IS_LOADING_CLIENTS_DATA';
const setIsLoadingClientsData = (isLoading) => ({
    type: SET_IS_LOADING_CLIENTS_DATA,
    isLoading,
});

export const SET_CLIENTS_SINGLE_SLUG = 'SET_CLIENTS_SINGLE_SLUG';
const setClientsSingleSlug = (slug) => ({
    type: SET_CLIENTS_SINGLE_SLUG,
    slug,
});

// Get all the clients
export const getClientsDataIfNeeded = () => (dispatch, getState) => {
    const { clientsData } = getState().clients;

    if (clientsData.length < 1) {
        const query = 'api/v1/getClientsData';

        dispatch(setIsLoadingClientsData(true));

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status !== 'success') {
                    throw 'error from server';
                } else {
                    const data = json.data;

                    dispatch(setClientsData(data.clientsData, data.allLocations));
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);
            }).finally(() => dispatch(setIsLoadingClientsData(false)));
    }

    return Promise.resolve(1);
};

// Get the data for one specific client
export const getClientsSingleDataIfNeeded = (slug) => (dispatch, getState) => {
    const { clientsSingleSlug } = getState().clients;

    if (clientsSingleSlug !== slug) {
        const query = `api/v1/getClientsSingleData/${slug}`;

        dispatch(setIsLoadingClientsData(true));

        return Api.progressGet(dispatch, query)
            .then((json) => {
                if (json.status !== 'success') {
                    throw 'error from server';
                } else {
                    dispatch(setClientsSingleData(json.data));

                    dispatch(setClientsSingleSlug(slug));
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);
            }).finally(() => dispatch(setIsLoadingClientsData(false)));
    }

    return Promise.resolve(1);
};
